// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1444":"f88e83e0","7442":"8c48f698","9290":"08841ff3"}[chunkId] + ".chunk.css";
};